module.exports = __webpack_public_path__ + "media/bridge_reference2.676e855a.mp3";